/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationactionedbadge2Inputs */

const en_moderationactionedbadge2 = /** @type {(inputs: Moderationactionedbadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actioned`)
};

const de_moderationactionedbadge2 = /** @type {(inputs: Moderationactionedbadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeitet`)
};

/**
* | output |
* | --- |
* | "Actioned" |
*
* @param {Moderationactionedbadge2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationactionedbadge2 = /** @type {((inputs?: Moderationactionedbadge2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationactionedbadge2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationactionedbadge2(inputs)
	return de_moderationactionedbadge2(inputs)
});
export { moderationactionedbadge2 as "moderationActionedBadge" }